import React, { useState, useEffect } from 'react';
import CountUp from 'react-countup';
import { books } from '../../data/books';
import { BASE_URL } from '../../data/constants';

// SVGs inline para compartilhamento do placar
const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" fill="white" className="w-4 h-4 flex-shrink-0">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);
const TwitterIcon = () => (
  <svg viewBox="0 0 24 24" fill="white" className="w-4 h-4 flex-shrink-0">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.742l7.737-8.835L1.254 2.25H8.08l4.261 5.635 5.903-5.635zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);
const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" fill="white" className="w-4 h-4 flex-shrink-0">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const TARGET_DATE = new Date('2026-10-25T21:00:00');

function getTimeLeft() {
  const diff = TARGET_DATE - Date.now();
  if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0, ended: true };
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
    ended: false,
  };
}

const pad = (n) => String(n).padStart(2, '0');

export const ScoreBoard = ({ sales, animatingNumber, handlePurchase }) => {
  const [timeLeft, setTimeLeft] = useState(getTimeLeft);
  const [copiedPlacar, setCopiedPlacar] = useState(false);

  useEffect(() => {
    const id = setInterval(() => setTimeLeft(getTimeLeft()), 1000);
    return () => clearInterval(id);
  }, []);

  const leader =
    sales.esquerda > sales.direita ? 'ESQUERDA' :
    sales.direita > sales.esquerda ? 'DIREITA' : null;

  const shareText = leader
    ? `${leader} esta liderando! Esquerda ${sales.esquerda} x ${sales.direita} Direita - Quem vai vencer na batalha dos ebooks politicos? Qual lado voce vai fortalecer?`
    : `Empate total! Esquerda ${sales.esquerda} x ${sales.direita} Direita - Quem vai vencer na batalha dos ebooks politicos? Qual lado voce vai fortalecer?`;
  const shareFull = `${shareText} ${BASE_URL}`;

  const handleCopyPlacar = async () => {
    try {
      await navigator.clipboard.writeText(shareFull);
      setCopiedPlacar(true);
      setTimeout(() => setCopiedPlacar(false), 2000);
    } catch {}
  };

  const AnimatedNumber = ({ side, id }) => {
    const book = books[side];
    if (!book) return null;
    const isLeft = side === 'esquerda';
    return (
      <div
        key={id}
        className={`fixed z-40 text-6xl font-bold pointer-events-none ${book.textColor}`}
        style={{
          left: isLeft ? '25%' : '75%',
          top: '70%',
          transform: 'translate(-50%, -50%)',
          animation: `moveToCounter-${side} 2s ease-out forwards`
        }}
      >
        +1
        <style jsx>{`
          @keyframes moveToCounter-esquerda {
            0% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
            70% { transform: translate(-50%, -300%) scale(0.8); opacity: 0.8; }
            100% { transform: translate(-50%, -300%) scale(0.5); opacity: 0; }
          }
          @keyframes moveToCounter-direita {
            0% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
            70% { transform: translate(-50%, -300%) scale(0.8); opacity: 0.8; }
            100% { transform: translate(-50%, -300%) scale(0.5); opacity: 0; }
          }
        `}</style>
      </div>
    );
  };

  return (
    <>
      {animatingNumber && (
        <AnimatedNumber side={animatingNumber.side} id={animatingNumber.id} />
      )}

      <section id="placar" className="py-12" aria-labelledby="placar-heading">
        <div className="bg-white rounded-3xl shadow-2xl p-8 border-4 border-gray-200">
          <div className="text-center mb-8">
            <h2 id="placar-heading" className="text-4xl font-bold text-gray-900 mb-2">
              🏆 PLACAR AO VIVO
            </h2>
            <p className="text-lg text-gray-600">Acompanhe a batalha em tempo real</p>
          </div>

          <div className="grid grid-cols-2 gap-2 sm:gap-4 lg:gap-8 relative">
            {/* Placar Esquerda */}
            <article className={`text-center p-2 sm:p-4 lg:p-8 ${books.esquerda.bgLight} rounded-xl lg:rounded-2xl border-2 lg:border-4 ${books.esquerda.borderColor} transform hover:scale-105 transition-all relative overflow-hidden`}>
              <div className="relative z-10">
                <div className="text-4xl sm:text-6xl lg:text-8xl mb-2 lg:mb-4" role="img" aria-label="Ícone do livro Esquerda">{books.esquerda.emoji}</div>
                <h3 className="text-sm sm:text-lg lg:text-2xl font-bold text-gray-800 mb-1 lg:mb-2">ESQUERDA</h3>
                <div className={`text-3xl sm:text-5xl lg:text-7xl font-black ${books.esquerda.textColor} mb-1 lg:mb-2 transition-all duration-500`}>
                  <CountUp end={sales.esquerda} duration={0.6} />
                </div>
                <div className="text-xs sm:text-sm lg:text-lg text-gray-600 font-semibold">VENDAS</div>
              </div>
            </article>

            {/* VS no meio */}
            <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20" role="img" aria-label="Versus">
              <div className="bg-yellow-400 text-yellow-900 w-8 h-8 sm:w-12 sm:h-12 lg:w-16 lg:h-16 rounded-full flex items-center justify-center text-sm sm:text-xl lg:text-2xl font-black border-2 lg:border-4 border-yellow-600 shadow-xl">
                VS
              </div>
            </div>

            {/* Placar Direita */}
            <article className={`text-center p-2 sm:p-4 lg:p-8 ${books.direita.bgLight} rounded-xl lg:rounded-2xl border-2 lg:border-4 ${books.direita.borderColor} transform hover:scale-105 transition-all relative overflow-hidden`}>
              <div className="relative z-10">
                <div className="text-4xl sm:text-6xl lg:text-8xl mb-2 lg:mb-4" role="img" aria-label="Ícone do livro Direita">{books.direita.emoji}</div>
                <h3 className="text-sm sm:text-lg lg:text-2xl font-bold text-gray-800 mb-1 lg:mb-2">DIREITA</h3>
                <div className={`text-3xl sm:text-5xl lg:text-7xl font-black ${books.direita.textColor} mb-1 lg:mb-2 transition-all duration-500`}>
                  <CountUp end={sales.direita} duration={0.6} />
                </div>
                <div className="text-xs sm:text-sm lg:text-lg text-gray-600 font-semibold">VENDAS</div>
              </div>
            </article>
          </div>

          {/* Indicador de liderança */}
          <div className="mt-4 lg:mt-6 text-center">
            <div className="inline-flex items-center px-3 lg:px-6 py-2 lg:py-3 bg-yellow-100 border-2 border-yellow-400 rounded-full">
              <span className="text-yellow-800 font-bold text-sm lg:text-lg">
                {sales.esquerda > sales.direita ? '👑 ESQUERDA LIDERANDO' :
                 sales.direita > sales.esquerda ? '👑 DIREITA LIDERANDO' :
                 '🤝 EMPATE'}
              </span>
            </div>
          </div>

          {/* Botões de compra rápida */}
          {handlePurchase && (
            <div className="mt-4 lg:mt-6 grid grid-cols-2 gap-2 sm:gap-3">
              <button
                onClick={() => handlePurchase('esquerda')}
                className={`flex flex-col items-center justify-center py-3 px-2 rounded-xl text-white font-bold transition-all hover:scale-105 shadow-lg ${books.esquerda.color} ${books.esquerda.hoverColor}`}
              >
                <span className="text-xs sm:text-sm leading-tight">🛒 Comprar — Esquerda</span>
                <span className="text-xs opacity-80 font-normal mt-0.5">{books.esquerda.price} · Download imediato</span>
              </button>
              <button
                onClick={() => handlePurchase('direita')}
                className={`flex flex-col items-center justify-center py-3 px-2 rounded-xl text-white font-bold transition-all hover:scale-105 shadow-lg ${books.direita.color} ${books.direita.hoverColor}`}
              >
                <span className="text-xs sm:text-sm leading-tight">🛒 Comprar — Direita</span>
                <span className="text-xs opacity-80 font-normal mt-0.5">{books.direita.price} · Download imediato</span>
              </button>
            </div>
          )}

          {/* Countdown */}
          <div className="mt-6 lg:mt-8 text-center">
            <p className="text-sm sm:text-base font-semibold text-gray-500 mb-3 uppercase tracking-wide">
              ⏳ A batalha termina em
            </p>
            {timeLeft.ended ? (
              <p className="text-2xl font-black text-red-600">🏁 A batalha encerrou!</p>
            ) : (
              <div className="flex items-center justify-center gap-2 sm:gap-3">
                {[
                  { value: timeLeft.days, label: 'DIAS' },
                  { value: timeLeft.hours, label: 'HRS' },
                  { value: timeLeft.minutes, label: 'MIN' },
                  { value: timeLeft.seconds, label: 'SEG' },
                ].map(({ value, label }, i) => (
                  <React.Fragment key={label}>
                    {i > 0 && (
                      <span className="text-2xl sm:text-4xl lg:text-5xl font-black leading-none -mt-3 select-none" style={{ color: '#F5A524' }}>:</span>
                    )}
                    <div className="flex flex-col items-center">
                      <div className="rounded-xl px-3 py-2 sm:px-4 sm:py-3 min-w-[3rem] sm:min-w-[4rem] lg:min-w-[5rem] shadow-lg" style={{ backgroundColor: '#F5A524' }}>
                        <span className="block text-2xl sm:text-4xl lg:text-5xl font-black tabular-nums leading-none" style={{ color: '#111827' }}>
                          {pad(value)}
                        </span>
                      </div>
                      <span className="text-xs font-bold text-gray-500 mt-1 tracking-wider">{label}</span>
                    </div>
                  </React.Fragment>
                ))}
              </div>
            )}
          </div>

          <p className="mt-4 text-center text-sm sm:text-base font-bold text-gray-700">
            🏆 O lado vencedor recebe um selo de ganhador
          </p>

          {/* Compartilhar placar */}
          <div className="mt-6 pt-6 border-t border-gray-100">
            <p className="text-center text-sm font-semibold text-gray-500 mb-3 uppercase tracking-wide">
              📣 Compartilhar o placar
            </p>
            <div className="flex flex-wrap gap-2 justify-center">
              <a
                href={`https://wa.me/?text=${encodeURIComponent(shareFull)}`}
                target="_blank" rel="noopener noreferrer"
                className="flex items-center gap-1.5 px-3 py-2 bg-[#25D366] text-white rounded-lg text-xs font-semibold hover:opacity-90 hover:scale-105 transition-all shadow-sm"
              >
                <WhatsAppIcon /> WhatsApp
              </a>
              <a
                href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(BASE_URL)}`}
                target="_blank" rel="noopener noreferrer"
                className="flex items-center gap-1.5 px-3 py-2 bg-black text-white rounded-lg text-xs font-semibold hover:opacity-90 hover:scale-105 transition-all shadow-sm"
              >
                <TwitterIcon /> Twitter / X
              </a>
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(BASE_URL)}&quote=${encodeURIComponent(shareText)}`}
                target="_blank" rel="noopener noreferrer"
                className="flex items-center gap-1.5 px-3 py-2 bg-[#1877F2] text-white rounded-lg text-xs font-semibold hover:opacity-90 hover:scale-105 transition-all shadow-sm"
              >
                <FacebookIcon /> Facebook
              </a>
              <button
                onClick={handleCopyPlacar}
                className="flex items-center gap-1.5 px-3 py-2 bg-gray-200 text-gray-700 rounded-lg text-xs font-semibold hover:bg-gray-300 hover:scale-105 transition-all shadow-sm"
              >
                {copiedPlacar ? '✅ Copiado!' : '🔗 Copiar link'}
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
